import { render } from "./EdvBottomBar.vue?vue&type=template&id=648c242b"
import script from "./EdvBottomBar.vue?vue&type=script&lang=js"
export * from "./EdvBottomBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__